import thunk from 'redux-thunk';
import { reportError } from 'ha/helpers/bugsnag/reportError';

import { realtimeMiddleware as talkRealtimeMiddleware } from 'ha/pages/Talk/middlewares/realtime';

import {
  delayWeWantToPayModal,
  openWeWantToPayModal,
} from 'ha/modules/WeWantToPay/middleware';
import { urlLocationMiddleware } from 'ha/modules/URLLocationHandler';
import { newTabMiddleware } from 'ha/modules/NewTabHandler';
import { persistentMiddleware as alerts } from 'ha/modules/Alertbar/middleware';
import { fixIosCaretIssue as fixIosCaretIssueMiddleware } from 'ha/modules/UI/middlewares/fixIosCaretIssue';
import { middleware as hotjarMiddleware } from 'ha/modules/Hotjar';
import { realtimeMessagingMiddleWare } from 'ha/modules/RealtimeMessaging/middleware';
import { inboxCounterMiddleware } from 'ha/modules/InboxCounter/middleware';

import { createCrashReporter as crashReporter } from './middlewares/crashReporter';
import { queryParamsMiddleware } from './middlewares/queryParams';
import { scrollMiddleware as scroll } from './middlewares/scroll';

import { getChannelId } from './getChannelId';
import { sanitizeState } from './sanitizeState';

const createAppMiddlewares = ({ debug, errorTracker, services, routerRef }) => {
  const commonMiddlewares = [thunk.withExtraArgument(services)];

  if (!process.browser) {
    return commonMiddlewares;
  }

  return [
    ...commonMiddlewares,
    hotjarMiddleware,
    urlLocationMiddleware(),
    newTabMiddleware(),
    queryParamsMiddleware({ routerRef }),
    delayWeWantToPayModal,
    openWeWantToPayModal,
    crashReporter(errorTracker, sanitizeState),
    alerts,
    scroll,
    fixIosCaretIssueMiddleware(global.document.body),
    realtimeMessagingMiddleWare({
      debug,
      onError: reportError,
      getChannelId,
    }),
    talkRealtimeMiddleware,
    inboxCounterMiddleware,
  ];
};
export { createAppMiddlewares };
